<template>
  <div class="custom-container">
    <div v-if="loader" class="loading-layout">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <div class="meldinger page-wrapp">
      <div class="meldinger_label">Meldinger</div>
      <div v-if="content">
        <div v-for="post in posts" class="newsletter-item" :key="post._id">
          <router-link v-if="post.displayed" :to="`/meldinger/${post.slug}`">
            <div>
              <div class="titlebar">
                <p class="title">{{ post.title }}</p>
              </div>
              <p class="content text--primary">{{ post.excerpt }}</p>
              <hr />
            </div>
          </router-link>
        </div>
      </div>
      <div v-if="!content">
        <p class="empty-error">Du har ingen meldinger</p>
      </div>
    </div>
  </div>
</template>
<script>
import './Meldinger.scss';

const getNewsletter = `*[_type == "newsletter" && displayed == true] | order(_updatedAt desc){
				_id,
				_updatedAt,
				excerpt,
				displayed,
				'slug': slug.current,
				title,
			}`;
export default {
  name: 'Meldinger',
  components: {},

  data() {
    return {
      loader: false,
      posts: [],
      content: false,
    };
  },
  beforeMount() {
    this.loader = true;
  },
  async created() {
    this.fetchNewsletter();
  },
  async mounted() {},
  methods: {
    async fetchNewsletter() {
      this.loader = true;

      await this.$sanity.fetch(getNewsletter).then(
        (posts) => {
          this.loader = false;
          this.posts = posts;
          if (this.posts.length > 0) {
            this.content = true;
          }
        },
        (error) => {
          this.error = error;
        }
      );
    },
  },
};
</script>
